<template>
  <div>
    <div class="header">
      <span class="h_back" @click="back"></span>
      <span class="h_title">{{detail.activityName}}</span>
    </div>
    <div class="h_msg">
      <div class="h_img">
        <img :src="detail.picUrl" alt="" class="h_imgbg">
      </div>
      <ul class="cp_base">
        <li>
          <img src="../assets/study1.svg" alt="">
          <span>{{detail.categoryName}}</span>
        </li>
        <li>
          <img src="../assets/study2.svg" alt="">
          <span>{{detail.activityTime}}</span>
        </li>
        <li class="mum_li">
          <img src="../assets/study3.svg" alt="">
          <span class="cp_mum">{{detail.speaker}}</span>
        </li>
        <li class="mum_li">
          <img src="../assets/study4.svg" alt="">
          <span class="cp_mum">{{detail.activityPlace}}</span>
        </li>
    </ul>
    <p class="cp_name">活动详情</p>
    <div class="cp_content" v-html="detail.content"></div>
    </div>
  </div>
</template>

<script>
  import { Indicator } from 'mint-ui';
  import {api} from '../global/api';
  export default {
    name: "studyDetail",
    data(){
      return{
        activityId:"",
        detail:{},//详情数据
      }
    },
    mounted(){
      this.init();
    },
    methods:{
      back(){
       // this.$router.go(-1);
       this.$router.back(-1)
        // this.$router.push({ path: 'activity', query: {newsType:'activitystudy'}})
      },
      init(){
        Indicator.open({text: '加载中...', spinnerType: 'fading-circle'});
        this.activityId = this.$route.query.id;
        const params = {activityId: this.activityId};
        this.$http.get(api.studyDetail, {params:params} ).then(response => {
          let { success,data }=response.data;
          if(success === 1){
            Indicator.close();
            this.detail = data.activity;
          }else{
            console.log("接口异常");
          }
          }, response => {
              console.log("请求失败了");
            })
      },
    }
  }
</script>

<style scoped >
  .header{
    width:100%;
    height: 2.25rem;
    background-color: rgba(196, 77, 65, 1);
    position: fixed;
    top: 0;
    z-index: 100;
  }
  .header span{
    display: block;
  }
  .h_title{
    height:  2.25rem;
    line-height:  2.25rem;
    color: rgba(255, 255, 255, 1);
    font-size: 0.8rem;
    text-align: center;
    font-family: PingFang-SC-Bold;
    width: 12rem;
    margin: 0 auto;
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
  }
  .h_back{
    background: url("../../static/images/cp_backbtn.svg") center no-repeat;
    background-size: 100% 100%;
    width: .55rem;
    height: 1rem;
    position: absolute;
    left: .75rem;
    top: 0;
    bottom: 0;
    margin: auto;
  }
  .cp_time,.cp_mum{
    height: 0.6rem;
    line-height: 0.6rem;
    color: rgba(153, 153, 153, 1);
    font-size: 0.6rem;
    text-align: left;
    font-family: PingFang-SC-Regular;
  }
  .h_chack{
    width: 1rem;
    height: 1rem;
    position: absolute;
    right: .75rem;
    top: 0;
    bottom: 0;
    margin: auto;
  }
  .off{
    background: url("../../static/images/checkoff.svg") center no-repeat;
    background-size: 100% 100%;
  }
  .on{
    background: url("../../static/images/checkon.svg") center no-repeat;
    background-size: 100% 100%;
  }
  .h_msg{
    width: 17.25rem;
    padding: 1rem .75rem;
    margin-top: 2.25rem;
  }
  .h_img{
    position: relative;
    text-align: center;
  }
  .h_imgbg{
    width: 17.25rem;
    height: 12.95rem;
    border-radius: 0.4rem;
    display: block;
  }
  .recorder{
    position: absolute;
    right: .6rem;
    top: .45rem;
    width: 2.1rem;
    height: 2.1rem;
  }
  .cp_name{
    width: 100%;
    color: rgba(196, 77, 65, 1);
    font-size: 0.8rem;
    text-align: left;
    font-family: PingFang-SC-Bold;
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
    margin-top: 0.5rem;
    margin-bottom: .5rem;
    font-weight: bold;
  }
  .cp_base:after{
    content: ".";
    display: block;
    clear: both;
    visibility: hidden;
    line-height: 0;
    height: 0;
  }
  .cp_base li{
    width: 16rem;
    height: .7rem;
    border-radius: 0.4rem;
    background-color: rgba(241, 241, 242, 1);
    margin-bottom: .5rem;
    padding: .6rem;
    margin-top: .5rem;
  }
  .cp_base img{
    display: inline-block;
    width: .8rem;
    height: .8rem;
    padding-bottom: .2rem;
  }
  .cp_base span{
    width: 14rem;
    height:.8rem;
    line-height:.9rem;
    color: rgba(51, 51, 51, 1);
    font-size: 0.7rem;
    text-align: left;
    vertical-align: top;
    font-family: PingFang-SC-Regular;
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
    display: inline-block;
    margin-left: .25rem;
  }
  .gotomap{
    width: .34rem;
    height: .6rem;
    position: absolute;
    right:.65rem;
    top: 0;
    bottom:0;
    margin: auto;
  }


  .mum_li{
    position: relative;
  }
  .cp_indroduce{
    width: 3.2rem;
    height: 0.7rem;
    line-height: 0.7rem;
    color: rgba(196, 77, 65, 1);
    font-size: 0.8rem;
    text-align: left;
    font-family: PingFang-SC-Bold;
    margin-top: .5rem;
    margin-bottom: .75rem;
  }
  .cp_content{
    width: 100%;
    overflow: hidden;
    line-height: 1.2rem;
    color: rgba(51, 51, 51, 1);
    font-size: 0.7rem;
    text-align: justify;
    font-family: PingFang-SC-Regular;
    margin-top: .5rem;
  }
</style>



// WEBPACK FOOTER //
// src/view/studyDetail.vue